<template>
  <div>
    <v-card-text>
      <v-container
        class="d-flex justify-center"
        v-if="$router.history.current.path == '/cadastrar-paciente'"
      >
        <p style="font-weight: bold">{{ $t('titles.fill_exams') }}</p>
      </v-container>
      <v-form
        @submit.prevent="saveExamsForm"
        ref="form"
        :disabled="disbaleForm"
      >
        <v-container>
          <v-row dense>
            <v-col class="d-flex" cols="12" sm="5" md="4">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :rules="formRules"
                :max="maxDateTime"
                @input="onDateTimeInput('examsForm','date_exam', $event)"
                outlined
                type="datetime-local"
                v-model="examsForm.date_exam"
                dense
              >
                <template v-slot:label>
                  {{ $t('inputs.exams.date_exam') }} <span style="color: red">*</span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <h3 class="span">{{ $t('titles.vital_signs') }}</h3>
          <v-row dense>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.t_graus')"
                :placeholder="$t('inputs.exams.t_graus_placeholder')"
                outlined
                v-model="examsForm.t_graus"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.pa')"
                :placeholder="$t('inputs.exams.pa_placeholder')"
                outlined
                v-model="examsForm.pa"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.pam')"
                :placeholder="$t('inputs.exams.pam_placeholder')"
                outlined
                v-model="examsForm.pam"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.fc')"
                :placeholder="$t('inputs.exams.fc_placeholder')"
                outlined
                v-model="examsForm.fc"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.diuresis')"
                outlined
                v-model="examsForm.diuresis"
                dense
              ></v-text-field>
            </v-col>  
          </v-row>
          <h3 class="span">{{ $t('titles.blood_gas_data') }}</h3>
          <v-row dense>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.sato2_pulmao')"
                outlined
                v-model="examsForm.sato2_pulmao"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.fio')"
                outlined
                v-model="examsForm.fio"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.po')"
                outlined
                v-model="examsForm.po"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.pco')"
                outlined
                v-model="examsForm.pco"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.ph')"
                outlined
                v-model="examsForm.ph"
                dense
              ></v-text-field>
            </v-col> 
          </v-row>
          <h3 class="span">{{ $t('titles.laboratory_test') }}</h3>
          <v-row dense>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.hb')"
                outlined
                v-model="examsForm.hb"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.ht')"
                outlined
                v-model="examsForm.ht"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.silly')"
                outlined
                v-model="examsForm.silly"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.plts')"
                :placeholder="$t('inputs.exams.plts_placeholder')"
                outlined
                v-model="examsForm.plts"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.tp')"
                outlined
                v-model="examsForm.tp"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.rni')"
                outlined
                v-model="examsForm.rni"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.canes')"
                outlined
                v-model="examsForm.canes"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.segmented')"
                outlined
                v-model="examsForm.segmented"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.glucose')"
                outlined
                v-model="examsForm.glucose"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.amylase')"
                outlined
                v-model="examsForm.amylase"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.tgo')"
                outlined
                v-model="examsForm.tgo"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.tgp')"
                outlined
                v-model="examsForm.tgp"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.gamagt')"
                outlined
                v-model="examsForm.gamagt"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.fosf')"
                outlined
                v-model="examsForm.fosf"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.bil_total')"
                outlined
                v-model="examsForm.bil_total"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.bil_direta')"
                outlined
                v-model="examsForm.bil_direta"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.creat')"
                outlined
                v-model="examsForm.creat"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.urea')"
                outlined
                v-model="examsForm.urea"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.na')"
                outlined
                v-model="examsForm.na"
                dense
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#256936"
                :label="$t('inputs.exams.k')"
                outlined
                v-model="examsForm.k"
                dense
              ></v-text-field>
            </v-col> 
          </v-row> 
          <v-row
            dense
            class="d-flex justify-end pa-3"
            v-if="
              $router.history.current.path != '/cadastrar-paciente' &&
              enableTable == true &&
              entrace_exams.length >= 1
            "
          >
            <v-btn class="rounded-lg mr-2" color="primary" @click="generate()">
              <span class="textBtn"
                ><v-icon class="mr-2" style="color: aliceblue"
                  >mdi-google-analytics</v-icon
                >{{ $t('buttons.view_in_graph') }}</span
              >
            </v-btn>
            <ExamesExcel :resource="entrace_exams" :patient="resource" />
          </v-row>

          <!-- Início da Tabela -->
          <v-data-table
            :headers="headers"
            :items="entrace_exams"
            :footer-props="{ 'items-per-page-text': 'Exames por Página' }"
            :loading="loading"
            v-if="enableTable == true"
          >
            <template #no-data>
              <div class="text-center py-4">{{ $t('messages.no_records_found')}}</div>
            </template>
            <template v-slot:[`item.date_exam`]="{ item }">
              {{ formatDate(item.date_exam) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }" :resource="item">
              <v-tooltip bottom color="#3fa118">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    size="22"
                    class="icon"
                    color="#3fa118"
                    align-item="center"
                    v-on="on"
                    v-bind="attrs"
                    @click="openView(item)"
                    >mdi-eye
                  </v-icon>
                </template>
                <span style="color: white">Visualizar Exame</span>
              </v-tooltip>
              <v-tooltip right color="#2ea8ff">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    size="22"
                    class="icon"
                    color="#2ea8ff"
                    align-item="center"
                    v-on="on"
                    v-bind="attrs"
                    @click="openViewEdit(item)"
                    >mdi-pencil
                  </v-icon>
                </template>
                <span style="color: white">{{$t('buttons.edit')}}</span>
              </v-tooltip>
            </template>
          </v-data-table>

          <v-dialog persistent width="500px" v-model="confirmDialog">
            <v-card class="deathDialog">
              <v-card-title class="text-h5">
                <v-icon dark class="donorIcon"
                  >mdi-checkbox-marked-circle</v-icon
                >
                {{ $t('messages.registred_exam') }}
              </v-card-title>
              <h4>
                {{ $t('messages.daily_exams') }}
              </h4>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#72ed82"
                  variant="text"
                  value="Sim"
                  @click="enableDialog()"
                >
                  ok
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog persistent width="1024" v-model="viewDialog">
            <v-card class="deathDialog">
              <v-card-title class="text-h5">
                <v-icon dark class="donorIcon">mdi-eye</v-icon>
                {{ $t('buttons.view')}}
              </v-card-title>
              <DialogComp />
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#72ed82"
                  variant="text"
                  value="Sim"
                  @click="enable()"
                >
                  {{ $t('buttons.ok')}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <br />
          <div class="buttons">
            <v-row class="d-flex justify-center">
              <v-btn
                class="rounded-lg action-btn"
                text
                outlined
                color="#41916b"
                @click="$router.push('/pacientes')"
                v-if="!isCreatePatientRoute"
              >
                <v-icon>mdi-arrow-left-bold</v-icon>
              </v-btn>

              <v-btn
                type="submit"
                class="rounded-lg action-btn"
                elevation="0"
                color="#41916b"
                v-if="!enableButtonEdit"
              >
                <span class="textBtn">{{$t('buttons.save')}}</span>
              </v-btn>

              <v-btn
                class="rounded-lg action-btn"
                elevation="0"
                color="#327d3c"
                v-if="enableButtonEdit"
                @click="edit(item)"
              >
                <span class="textBtn">{{$t('buttons.to_update')}}</span>
              </v-btn>

              <v-btn
                class="rounded-lg action-btn"
                elevation="0"
                color="#267851"
                @click="changeTable()"
                v-if="!isCreatePatientRoute"
              >
                <span class="textBtn">
                  <v-icon class="mr-1">
                    {{ enableTable ? "mdi-eye-off" : "mdi-eye" }}
                  </v-icon>
                  {{
                    enableTable
                      ? $t('buttons.hide_exames')
                      : "Exibir Exames Realizados"
                  }}
                </span>
              </v-btn>

              <p
                class="space-personalized"
                v-if="!isCreatePatientRoute"
              ></p>

              <v-btn
                class="rounded-lg action-btn"
                elevation="0"
                color="#8ead95"
                @click="$emit('fechar')"
                v-if="isCreatePatientRoute"
              >
                <span class="textBtn">{{ $t('buttons.fill_in_another_moment') }}</span>
              </v-btn>
            </v-row>
          </div>
        </v-container>
      </v-form>

      <v-dialog max-width="50%" persistent v-model="graphDialog">
        <v-card class="rounded-lg pa-6" style="overflow: hidden">
          <v-card-text>
            <v-autocomplete
              class="rounded-lg"
              :items="exams"
              item-value="name"
              item-text="name"
              v-model="exam"
              label="Selecione o exame que gostaria de visualizar"
              color="#256936"
              outlined
              dense
              @change="generate()"
            >
            </v-autocomplete>
            <div
              id="chart"
              style="width: 100%; min-height: 300px; overflow: visible"
              v-if="exam"
            ></div>
          </v-card-text>

          <v-card-actions class="d-flex justify-center">
            <v-btn
              class="rounded-lg mr-1"
              text
              outlined
              elevation="0"
              color="#41916b"
              @click="(graphDialog = false), (exam = false)"
            >
              <span color="#41916b">{{$t('buttons.close')}}</span>
            </v-btn> 
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>

    <v-snackbar
      absolute
      background-color="white"
      color="#104a21"
      v-model="snackbar"
    >
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          {{$t('buttons.close')}}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import c3 from "c3";
import axios from "@/axios";
import ExamesExcel from "./ExamesExcel.vue";
import dateTimeLimit from "@/utils/dateTimeLimit";
import currentUser from "@/utils/currentUser";
import Formatters from "@/utils/Formatters";
export default {
  data() {
    return {
      headers: [
        {
          text: "Data de Entrada de Exame",
          value: "created_at",
          align: "center",
        },
        {
          text: "Data e Hora da Realização Exame",
          value: "date_exam",
          align: "center",
        },
        {
          text: "Responsável pelo cadastro",
          value: "users.name",
          align: "center",
        },
        {
          text: "Ações",
          value: "actions",
          align: "center",
        },
      ],
      dialog: false,
      displayError: {
        display: false,
        message: [],
      },
      donor_id: "",
      itemID: "",
      loading: true,
      options: {},
      donor_name: "",
      entrace_exams: [],
      message: "",
      snackbar: false,
      messageError: "",
      enableButton: true,
      enableButtonEdit: false,
      enableTable: false,
      disbaleForm: false,
      disableButton: false,
      confirmDialog: "",
      viewDialog: "",
      examsForm: {
        donor_id: "",
        user_id: "",
      },
      formRules: [(v) => !!v || "Este campo é obrigatório",
      v => new Date(v) <= new Date() || 'Não pode ser data futura',
      ],
      exams: [],
      exam: "",
      graphItems: [],
      graphDialog: false,
    };
  },
  created() {},

  components: {
    ExamesExcel,
  },

  props: {
    donorId: Number,
  },

  computed: {
    ...mapGetters({
      resource: "getPatientData",
    }), 

    isCreatePatientRoute() {
      return this.$router.history.current.path === "/cadastrar-paciente";
    },
    currentUser(){
      return currentUser.getUserData()
    },
    maxDateTime() {
      const now = new Date()
        return now.toISOString().slice(0, 16)     
    }
  },

  methods: {
    ...mapActions(["changeSnackBarData"]),

    onDateTimeInput(path,field, value) { 
       this[path][field] =
        dateTimeLimit.limitYearField(value)
    },
    loadGridData() {
       if (!this.resource?.id) {
        this.loading = false;
        return;
  }
      this.loading = true;
      this.donor_name = this.resource.name;
      axios.get(`/entrace_exams/${this.resource.id}`).then((response) => {
        this.loading = false;
        this.entrace_exams = response.data;

        const ignoredKeys = [
          "id",
          "donor_id",
          "user_id",
          "date_exam",
          "created_at",
          "updated_at",
          "users",
        ];

        this.exams = Object.entries(this.entrace_exams[0])
          .filter(([key]) => !ignoredKeys.includes(key))
          .map(([key]) => ({
            id: key,
            name: key,
          }));
      });
    },

    ative() {
      this.confirmDialog = true;
    },
    enableDialog() {
      this.confirmDialog = false;
    },

    enable() {
      this.viewDialog = false;
    },

    changeTable() {
      if (this.enableTable == false) {
        this.enableTable = true;
        this.disableButton = true;
        this.loadGridData();
      } else {
        this.enableTable = false;
        this.disableButton = false;
        this.disbaleForm = false;
        this.$refs.form.resetValidation();
        this.examsForm = {};
      }
    },

    saveExamsForm() {
      if (this.$refs.form.validate()) {
        this.examsForm.donor_id = this.resource.id
          ? this.resource.id
          : this.donorId;
        this.examsForm.user_id = this.currentUser.id;
        this.examsForm.date_exam = this.formatDateTimeToBackend(
          this.examsForm.date_exam
        );
        const exams = this.examsForm;
        axios
          .post(`/entrace_exams`, exams)
          .then((response) => {
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "#41916b",
              titleIcon: "mdi-checkbox-marked-circle",
            });

            setTimeout(() => {
              if (this.$router.history.current.path == "/cadastrar-paciente") {
                this.$emit("fechar");
              } else {
                this.confirmDialog = true;
                this.examsForm = "";
                this.$refs.form.reset();
                this.enableButton = false;
                this.dialog = false;
                this.loadGridData();
              }

              this.closeSnackBar();
            }, 3000);
          })
          .catch((err) => { 
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: Formatters.formatErrorMessage(err),
              bodyMessage: "",
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });

            setTimeout(() => {
              this.closeSnackBar();
            }, 5000);
          });
      }
    },

    openViewEdit(item) {
      this.examsForm = item;
      this.itemID = item.id;
      this.disbaleForm = false;
      this.enableButton = false;
      this.enableButtonEdit = true;
    },

    openView(item) {
      this.examsForm = item;
      this.disbaleForm = true;
      this.enableButton = false;
    },

    edit() {
      let exame = this.examsForm;
      exame.date_exam = this.formatDateTimeToBackend(this.examsForm.date_exam);

      axios
        .put(`/entrace_exams/${this.itemID}`, exame)
        .then((response) => {
          this.message = response.data.message;
          this.snackbar = true;
          this.enableButtonEdit = false;
        })
        .catch((err) => {
          err;
          var error = "";
          Object.values(this.$store.state.errorMessage).map((value) => {
            error = value;
          });

          this.displayError.message = error.toString();
          this.displayError.display = true;
          setTimeout(() => {
            this.displayError.display = false;
          }, 3000);
        });
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${day}-${month}-${year} ${hours}:${minutes}`;
    },

    formatDateTimeToBackend(value) {
      if (!value) return null;
      return value.replace("T", " ").slice(0, 16);
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },

    generate() {
      this.graphDialog = true;

      this.$nextTick(() => {
        this.prepareData();

        const chartOptions = {
          bindto: "#chart",
          data: {
            x: "x",
            columns: this.graphItems,
            type: "line",
            colors: { data1: "purple" },
          },
          axis: {
            x: {
              type: "timeseries",
              tick: { format: "%d-%m-%Y" },
            },
          },
          padding: { right: 20 },
        };

        c3.generate(chartOptions);
      });
    },

    prepareData() {
      const data = this.entrace_exams;
      const itensIgnorados = [
        "id",
        "donor_id",
        "user_id",
        "created_at",
        "updated_at",
        "users",
      ];
      const exameSelecionado = this.exam;

      if (!exameSelecionado) return;

      // tradução de nomes
      const nomesExames = {
        hb: "Hemoglobina",
        glucose: "Glicose",
        diuresis: "Diurese",
        ht: "Hematócrito",
        tp: "Tempo de Protrombina",
        blood_products: "Hemocomponentes",
        silly: "Sódio Sérico",
        rni: "RNI",
        vasoative_drugs: "Drogas Vasoativas",
        canes: "Cânulas",
        amylase: "Amilase",
        antibiotics: "Antibióticos",
        segmented: "Segmentados",
        tgo: "TGO",
        pa: "Pressão Arterial",
        plts: "Plaquetas",
        tgp: "TGP",
        pam: "Pressão Arterial Média",
        urea: "Ureia",
        fosf: "Fósforo",
        fc: "Frequência Cardíaca",
        creat: "Creatinina",
        gamagt: "Gama GT",
        t_graus: "Temperatura (°C)",
        na: "Sódio",
        bil_total: "Bilirrubina Total",
        bil_direta: "Bilirrubina Direta",
        sat: "Saturação O₂",
        k: "Potássio",
        fio: "FiO₂",
        ph: "pH",
        po: "pO₂",
        pco: "pCO₂",
        sato2_pulmao: "Saturação O₂ Pulmonar",
      };

      const nomeExameFormatado =
        nomesExames[exameSelecionado] || exameSelecionado;

      const columnsObj = data.reduce((acc, item) => {
        const date = item.date_exam.split(" ")[0];

        // eixo X
        if (!acc.x) acc.x = ["x"];
        acc.x.push(date);

        // só o exame selecionado
        if (
          Object.prototype.hasOwnProperty.call(item, exameSelecionado) &&
          !itensIgnorados.includes(exameSelecionado)
        ) {
          if (!acc[exameSelecionado])
            acc[exameSelecionado] = [nomeExameFormatado];

          const valor =
            item[exameSelecionado] !== null
              ? Number(item[exameSelecionado])
              : null;
          acc[exameSelecionado].push(isNaN(valor) ? null : valor);
        }

        return acc;
      }, {});

      const columns = Object.values(columnsObj);

      this.graphItems = columns;
    },
  },

  mounted() {
    this.loadGridData();
  },
};
</script>

<style scoped>
.span {
  margin-bottom: 10px;
  margin-left: 5px;
}
.deathDialog {
  background-color: #fafffc;
}
.deathDialog > h4 {
  color: #413f3f;
  padding: 20px;
}
.text-h5 {
  background-color: #41a84f;
  color: white;
}
.donorIcon {
  padding: 8px 8px 8px 0;
}
.header-table {
  display: flex;
  margin-bottom: 20px;
}

p {
  font-size: 16px;
  /* font-weight: bold; */
}
.d-flex {
  padding: 0 12px;
}

.space {
  width: 5px;
}

.space-personalized {
  padding: 4px;
}

.spacediferent {
  width: 7px;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.create-user-dialog {
  padding: 20px;
}

.card {
  padding: 35px;
}

.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #0ca673, #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #0cb087, #66f9b9);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.textBtn {
  color: #ffffff;
}
.banner > h3 {
  color: #ffffff;
  padding: 18px 0 18px 0;
}
.modalIcon {
  padding: 12px;
}

.cardFooter {
  padding: 0 !important;
}

.action-btn {
  margin-right: 4px;
}

@media (max-width: 768px) {
  .buttons .v-row {
    flex-direction: column;
  }

  .action-btn {
    width: 100%;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .space-personalized {
    display: none;
  }
}
</style>
